const VUESTIC_ICON_MAP: Record<string, string> = {
  'vuestic-iconset-dashboard': 'monitor',
  'vuestic-iconset-statistics': 'query_stats',
  'vuestic-iconset-tables': 'table_chart',
  'vuestic-iconset-ui-elements': 'widgets',
  'vuestic-iconset-forms': 'edit_note',
  'vuestic-iconset-maps': 'map',
  'vuestic-iconset-charts': 'bar_chart',
}

/** Vuetify default aliases use MDI names — map to Material Symbols ligatures. */
const MDI_TO_MATERIAL: Record<string, string> = {
  'mdi-chevron-up': 'expand_less',
  'mdi-chevron-down': 'expand_more',
  'mdi-chevron-left': 'chevron_left',
  'mdi-chevron-right': 'chevron_right',
  'mdi-menu-down': 'arrow_drop_down',
  'mdi-menu-right': 'chevron_right',
  'mdi-menu': 'menu',
  'mdi-close': 'close',
  'mdi-close-circle': 'cancel',
  'mdi-check': 'check',
  'mdi-check-circle': 'check_circle',
  'mdi-information': 'info',
  'mdi-alert-circle': 'error',
  'mdi-cached': 'sync',
  'mdi-calendar': 'event',
  'mdi-magnify': 'search',
  'mdi-pencil': 'edit',
  'mdi-plus': 'plus',
  'mdi-minus': 'remove',
  'mdi-checkbox-marked': 'check_box',
  'mdi-checkbox-blank-outline': 'check_box_outline_blank',
  'mdi-minus-box': 'indeterminate_check_box',
  'mdi-circle': 'circle',
  'mdi-arrow-up': 'arrow_upward',
  'mdi-arrow-down': 'arrow_downward',
  'mdi-arrow-left': 'arrow_back',
  'mdi-arrow-right': 'arrow_forward',
  'mdi-radiobox-marked': 'radio_button_checked',
  'mdi-radiobox-blank': 'radio_button_unchecked',
  'mdi-star': 'star',
  'mdi-star-outline': 'star_border',
  'mdi-star-half-full': 'star_half',
  'mdi-page-first': 'first_page',
  'mdi-page-last': 'last_page',
  'mdi-unfold-more-horizontal': 'unfold_more',
  'mdi-paperclip': 'attach_file',
  'mdi-eyedropper': 'colorize',
  'mdi-cloud-upload': 'cloud_upload',
  'mdi-palette': 'palette',
  'mdi-play': 'play_arrow',
  'mdi-pause': 'pause',
  'mdi-fullscreen': 'fullscreen',
  'mdi-fullscreen-exit': 'fullscreen_exit',
  'mdi-volume-high': 'volume_up',
  'mdi-volume-medium': 'volume_down',
  'mdi-volume-low': 'volume_mute',
  'mdi-volume-variant-off': 'volume_off',
  'mdi-backspace': 'backspace',
  'mdi-keyboard-return': 'keyboard_return',
  'mdi-keyboard-space': 'space_bar',
}

function mdiNameToMaterial(name: string): string {
  if (MDI_TO_MATERIAL[name]) {
    return MDI_TO_MATERIAL[name]
  }

  if (name.startsWith('mdi-')) {
    return name.slice(4).replace(/-/g, '_')
  }

  return name
}

/** Normalize Vuestic / MDI / legacy icon names to Material Symbols ligatures. */
export function normalizeIconName(icon?: string | null): string {
  if (!icon) return ''

  let name = icon.trim()

  if (name.startsWith('mso-')) {
    name = name.slice(4)
  } else if (name.startsWith('md_')) {
    name = name.slice(3)
  } else if (name.startsWith('mdi-')) {
    return mdiNameToMaterial(name)
  }

  if (VUESTIC_ICON_MAP[name]) {
    return VUESTIC_ICON_MAP[name]
  }

  return name
}

/** Remap Vuetify MDI aliases to Material Symbol names for the active icon set. */
export function remapMdiAliases<T extends Record<string, string>>(aliases: T): T {
  return Object.fromEntries(Object.entries(aliases).map(([key, value]) => [key, normalizeIconName(value)])) as T
}
